import React from "react";

import { BrandLockup } from "../BrandLockup";
import { ButtonLink } from "../../../components/ButtonLink/ButtonLink";
import { datas, planos } from "../../../utils/copy";
import manuJanela from "../../../assets/images/ConversasTerapeuticas/ultima-foto.jpg";

export function Fechamento() {
  return (
    <section id="fechamento" data-bg="#1f1016" className="poster-section closing-section dark-sec">
      <div className="closing-copy">
        <BrandLockup light />
        <h2 data-motion="title" className="type-display"><span>Tem temas que</span><span>a gente rodeia</span><span>a vida inteira.</span></h2>
        <p data-motion="lead" className="type-voice closing-subtitle">Este é o ano de atravessar.</p>
        <p className="closing-meta">
          Turma de 2026
          <br />
          ·&nbsp;inscrições de <span className="closing-meta-range">{datas.abertura} a {datas.fechamento}</span>
        </p>
        <div className="closing-actions">
          <ButtonLink variant="solid" href="#investimento">{planos.anual.cta}</ButtonLink>
          <ButtonLink href="#investimento" arrow>{planos.trimestral.cta}</ButtonLink>
        </div>
        <p className="closing-footer">Conversas Terapêuticas por Manuela Xavier · Estudos da vida feminina · Turma de 2026</p>
      </div>
      <figure data-motion="media" className="closing-photo">
        <img
          src={manuJanela}
          alt="Retrato de Manuela Xavier sobre fundo escuro"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </figure>
    </section>
  );
}
